import type { ConferenceRankingItem } from "./conferenceRankings";

export function getConferenceTableItemTemplate(item: ConferenceRankingItem & { thumbnailUrl?: string }) {
    const location = item.isOnline ? "Online" : item.address || item.location || "TBD";

    let conferenceDate = "TBD";
    if (item.startDate) {
        conferenceDate =
            item.endDate && item.startDate !== item.endDate ? `${item.startDate} - ${item.endDate}` : item.startDate;
    } else if (item.conferenceDate) {
        conferenceDate = item.conferenceDate;
    }

    return `
    <div class="cols conference-item rankings-content__item">
      <span class="col col--3-12 col--tablet cols mx-0 py-0 positions">
        <span class="col col--2 col--tablet position px-0">
          ${item.rank || "-"}
          <span class="show-tablet desc">Rank</span>
        </span>
        <span class="col col--4 px-0 py-0 hide-tablet img">
          ${item.thumbnailUrl ? `<img class="lazyload" src="${item.thumbnailUrl}" onerror="this.src='/classic-rankings-frontend/images/article-placeholder.png'" alt="${item.publisher.name}" loading="lazy" />` : ""}
        </span>
      </span>
      <div class="col col--5-12 col--tablet py-0 info">
        <h4><a href="/conference/${item.slug}" class="text-primary hover:underline" target="_blank">${item.name}</a></h4>
        <div class="text-sm mt-1">
          <span>${conferenceDate}</span>
          <span class="mx-1">·</span>
          <span class="font-semibold">${location}</span>
        </div>
      </div>
      <span class="rankings-info flex items-center !justify-center md:justify-end">
      <span class="col col--2 col--tablet py-0 ranking border-0">
          <span class="show-tablet desc">H-Index</span>
          <span class=" ranking no-wrap">${item.dIndex ?? "-"}</span>
      </span>
      </span>
    </div>
    `;
}
